// Adapter for measurement report API endpoints

// For report export requests (input from UI to API)
export const toMeasurementReportApi = (uiObj) => {
    const requestData = {
        meter__in: uiObj.meterIds, // Array of integers
        measured_ts_from: uiObj.dateFrom, // Format: 'YYYY-MM-DD HH:MM:SS'
        measured_ts_to: uiObj.dateTo, // Format: 'YYYY-MM-DD HH:MM:SS'
        resolution: uiObj.resolution || 'hour' // Enum: "10min" or "hour"
    }
    return requestData
}

// For report response (from API to UI)
export const fromMeasurementReportApi = (apiObj) => {
    // API returns JSON response: { "status": "ok", "code": "ok", "results": "Report request was saved." }
    return {
        status: apiObj.status,
        code: apiObj.code,
        message: apiObj.results
    }
}

// Legacy bug report adapter (keeping for backward compatibility)
export const toReportApi = (apiObj) => {
    const responseData = apiObj
    return {
        email: responseData.raportEmail,
        description: responseData.raportContent
    }
}

export default toMeasurementReportApi
